<template>
   <div class="tooltip">
      <div class="top">
         <slot/>
         <i></i>
      </div>
      <img src="../assets/icons/information.svg"
           alt="info">
   </div>
</template>

<script>
    export default {
        name: "TooltipMark"
    }
</script>

<style scoped lang="scss">
   @import "../theme/theme";

   .tooltip {
      grid-column: 1;
      grid-row: 1;
      display: inline-block;
      position: relative;
      text-align: left;

      .top {
         min-width: 200px;
         max-width: 400px;
         top: -10px;
         left: 40%;
         transform: translate(-15%, -100%);
         padding: 0.8rem 0.8rem;
         color: $primaryText100;
         text-align: justify;
         background-color: $primary10;
         font-weight: 300;
         font-size: 1rem;
         border-radius: 0.5rem;
         position: absolute;
         z-index: 99999999;
         box-sizing: border-box;
         box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
         display: block;
         visibility: hidden;
         opacity: 0;
         transition-duration: 0.25s;
         pointer-events: none;

         i {
            position: absolute;
            top: 100%;
            left: 15%;
            margin-left: -1rem;
            width: 2rem;
            height: 1rem;
            overflow: hidden;
         }

         i::after {
            content: '';
            position: absolute;
            width: 1rem;
            height: 1rem;
            left: 50%;
            transform: translate(-50%, -50%) rotate(45deg);
            background-color: $primary10;
            box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
         }
      }

      img {
         width: 1.3rem;
      }
   }

   .tooltip:hover .top {
      visibility: visible;
      opacity: 1;
      transition-duration: $animationDuration;
   }

</style>